import { Country } from '@afterpay/types'
import { Theme } from '@afterpaytouch/core'
import { TerminalErrorCode, ThemedImageMap } from '../../model'
import { TrackingEvent } from '../../model/monitoring'
import { AlternativeOptionType, LinkAmpEvent } from './types'

export const TERMINAL_ERROR_CODE_IMAGE_MAP: { [key in TerminalErrorCode]?: ThemedImageMap } = {
  [TerminalErrorCode.Default]: {
    [Theme.AP]: 'default-mint--light.svg',
    [Theme.Cash]: 'default-green--light.svg',
    [Theme.Pegasus]: { dark: 'default-green--dark.svg', light: 'default-green--light.svg' },
  },
}

export const getLinkAmpEvent = (error: string, url?: string): LinkAmpEvent => ({
  event: TrackingEvent.PRESSED_TERMINAL_ERROR_LINK,
  options: { error, targetUrl: url ?? '' },
})

export const isAlternativeOptionTypeArray = (obj: unknown): obj is AlternativeOptionType[] => {
  if (!Array.isArray(obj) || obj.length === 0) {
    return false
  }
  return obj.every((item) => item && typeof item.title === 'string')
}

export interface ShouldHideDescriptionParams {
  isAmountTooHigh: boolean
  context: string
  isOrderAmountExceedsSpendCap: boolean
  errorKey: TerminalErrorCode
  country: Country
}

export const shouldHideDescription = (params: ShouldHideDescriptionParams): boolean => {
  const { isAmountTooHigh, context, isOrderAmountExceedsSpendCap, errorKey, country } = params

  const isClAuDeclineWithAmountTooHigh = isAmountTooHigh && context === 'clAuDeclined'
  const isOrderAmountTooHighError = errorKey === TerminalErrorCode.OrderAmountTooHigh
  const isOrderAmountTooHighErrorForGB = isOrderAmountTooHighError && country === Country.GB

  if ([isOrderAmountTooHighErrorForGB].some((condition) => condition)) {
    return false
  }

  if ([isClAuDeclineWithAmountTooHigh, isOrderAmountExceedsSpendCap, isOrderAmountTooHighError].some((condition) => condition)) {
    return true
  }

  return false
}
